<template>
	<div class="wrapper award">
		<div class="content">
			<div class="topbar">
				<div class="logo">
					<router-link to="/profile"><img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" class="logo" /></router-link>
				</div>
				<div class="info">
					<router-link to="/notifications" class="notifications">
						<div class="icon">
							<div v-if="notificationsUnread" class="counter">{{ notificationsUnread }}</div>
						</div>
					</router-link>
					<div class="profile">
						<img :src="avatarImage" :alt="avatarName" class="currentAvatar" />
					</div>
				</div>
			</div>
			<h2>{{ t('txt_hello') }},</h2>
			<h1>{{ fullName }}</h1>
		</div>

		<div v-if="award" class="award-details">
			<div class="top">
				<div class="info">
					<h2>{{ award.title }}</h2>
					<div class="location">{{ t('txt_at') }} <router-link :to="`/providers/map/${award.partner_id}`">{{ award.partner_title }}</router-link></div>
					<div class="detailed-location">
						{{ award.partner_address}}<br>{{ award.partner_post_number }} {{ award.partner_post_name }}<br>{{ award.partner_country }}
					</div>
				</div>
				<!-- <div class="image"></div> -->
			</div>
			<div class="wrap">
				<div class="error animate__animated animate__headShake" ref="error"></div>
				<div class="success animate__animated animate__shakeY" ref="success"></div>
				<p class="cta" v-if="used == null">{{ t('txt_scan_qr_get_award') }}</p>
				<button v-if="used == null" @click="startScanning" ref="qrscan" class="green">{{ t('txt_scan_qr') }}</button>
				<div class="until" ref="until">{{ t('txt_until') }} {{ formatDate(award.valid_until, 'L') }}</div>
			</div>
		</div>
		<div v-if="scanning" class="qr-code-wrapper">
			<div id="qr-reader" class="qr-reader full-screen"></div>
			<div class="button-wrap">
				<button @click="stopScanning" ref="qrscan" class="green">{{ t('txt_stop_scan_qr') }}</button>
			</div>
		</div>
	</div>
	<MobileNav :selected="selectedId" />
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import apiClient from '@/utils/axios';
import { Html5Qrcode } from "html5-qrcode";
import { nextTick } from 'vue';
import dayjs from '@/utils/dayjs';

export default {
	props: ['id'],
	name: 'AwardDetail',
	data() {
		return {
			selectedId: 3,
			scanning: false,
			award: null,
			used: null,
			selectedAvatar: localStorage.getItem('avatar'),
			avatars: [
				{ id: '1', image: require('../assets/img/eda-spomenik.svg'), name: 'fox' },
				{ id: '2', image: require('../assets/img/goriska-vrtnica.svg'), name: 'goriska-vrtnica' },
				{ id: '3', image: require('../assets/img/goriski-grad.svg'), name: 'goriski-grad' },
				{ id: '4', image: require('../assets/img/soca.svg'), name: 'soca' },
				{ id: '5', image: require('../assets/img/solkanski-most.svg'), name: 'solkanski-most' },
				{ id: '6', image: require('../assets/img/solkanski-radic.svg'), name: 'solkanski-radic' },
				{ id: '7', image: require('../assets/img/soska-postrv.svg'), name: 'postrv' },
				
			],
			notificationsUnread: 0,
		};
	},
	computed: {
		fullName() {
			return `${keycloak.tokenParsed?.given_name || 'Name'} ${keycloak.tokenParsed?.family_name || 'Surname'}`;
		},
		avatarImage() {
			return this.getAvatarById(this.selectedAvatar)?.image || this.getAvatarById('1')?.image;
		},
		avatarName() {
			return this.getAvatarById(this.selectedAvatar)?.name || this.getAvatarById('1')?.name;
		}
	},
	methods: {
		getAvatarById(id) {
			return this.avatars.find(avatar => avatar.id === id);
		},
		async fetchAward() {
			try {
				const lang = localStorage.getItem('lang') || 'en';
				const response = await apiClient.get(`/${lang}/api/award/${this.id}`);
				this.award = response.data;
				this.notificationsUnread = response.data.notificationsUnread;
			} catch (error) {
				console.error('Error fetching award:', error);
			}
		},
		async confirmQr(qr){
			this.isAuthenticated = keycloak.authenticated;
			if (this.isAuthenticated) {
				try {
					const lang = localStorage.getItem('lang') || 'en';
					const data = { 'qr':qr };
					const response = await apiClient.post(`/${lang}/api/use/${this.id}`, data);
					if(response.data){
						this.used = response.data;
						console.log(this.used);
						if(this.used.error == true){
							this.$refs.error.classList.add('visible');
							this.$refs.success.classList.remove('visible');
							console.log(this.$refs.error.classList);
						} else if(this.used.error == false){
							this.$refs.success.classList.add('visible');
							this.$refs.error.classList.remove('visible');
							console.log(this.$refs.error.classList);
							this.$refs.until.innerHTML = this.t('txt_used')+ ' '+this.formatDate(this.used.date, 'L LT');
						}
					}
				} catch (error) {
					console.error('Error fetching point:', error);
				}
			}
		},
		startScanning() {
			this.scanning = true;
			nextTick(() => {
				setTimeout(() => {
					this.initializeQrScanner();
				}, 100);
			});
		},
		stopScanning() {
			if (this.html5QrCode) {
				this.html5QrCode.stop().then(() => {
					this.scanning = false;
				}).catch(err => {
					console.error("Error stopping scanner:", err);
				});
			}
		},
		initializeQrScanner() {
			const qrCodeRegionId = "qr-reader";
			const element = document.getElementById(qrCodeRegionId);
			if (!element) {
				return;
			}

			this.html5QrCode = new Html5Qrcode(qrCodeRegionId);

			let isScanning = false;

			this.html5QrCode.start(
				{ facingMode: "environment" },
				{
				fps: 15,
				qrbox: { width: 250, height: 250 },
				},
				(decodedText) => {
				const scannerElement = document.getElementById(qrCodeRegionId);
				if (scannerElement) {
					scannerElement.style.border = "5px solid #29CCB1";
				}

				if (!isScanning) {
					isScanning = true;

					setTimeout(() => {
					if (this.html5QrCode.isScanning) {
							this.html5QrCode.stop().then(() => {
							this.scanning = false;
							this.confirmQr(decodedText); 
							isScanning = false;
						}).catch(console.error);
					} else {
						this.scanning = false;
						this.confirmQr(decodedText);
						isScanning = false;
					}
					}, 1000);
				}
				}
			).then(() => {
				setTimeout(() => {
				const video = document.querySelector('#qr-reader > video');
				if (video) {
					video.style.width = '100%';
					video.style.height = '100%';
					video.style.objectFit = 'cover';
				}
				}, 100);
			}).catch((err) => {
				console.error("Camera initialization failed:", err);
			});
			},
		formatDate(date, format ='L LT') {
			return dayjs(date).locale(localStorage.getItem('lang')).format(format);
		}
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	},
	mounted() {
		this.fetchAward();
	},
};
</script>

<style lang="sass" scoped>

</style>